import { useI18nContext } from 'src/i18n/i18n-react';
import ArrowRight from 'src/assets/svgicons/line/arrow-right.svg';
import { cn } from 'src/lib/cn';
import { Badge } from '../Badge';
import { AriaButton } from '../Button';
import { comingSoonPlatforms } from '../OnboardingModal/constants';

export default function ComingSoonAdAccountPlatforms({
  className,
}: {
  className?: string;
}) {
  const { LL } = useI18nContext();

  return (
    <div className={cn('space-y-2', className)}>
      {comingSoonPlatforms.map((platform) => (
        <AriaButton
          key={platform.name}
          variant="custom"
          className="group h-fit w-full justify-start rounded-lg border border-solid border-purple-200 !p-3 hover:bg-purple-100 disabled:opacity-50"
          isDisabled
        >
          <div className="rounded-lg border border-solid border-secondary/80 bg-white p-2 *:size-6">
            {platform.icon}
          </div>
          <div className="space-y-0.5">
            <div className="flex items-center gap-2 text-left">
              <h3 className="text-sm font-semibold">{platform.name}</h3>
              <Badge
                className="bg-purple-100 text-xxs text-primary/70"
                variant="pill"
              >
                {LL.comingSoon()}
              </Badge>
            </div>
            <p className="text-xs font-medium text-[#917DD2]">
              {LL.insights.onboarding[platform.descriptionKey]()}
            </p>
          </div>
          <ArrowRight className="ml-auto size-5 -translate-x-px opacity-50 transition-transform group-hover:translate-x-0 group-hover:opacity-100" />
        </AriaButton>
      ))}
    </div>
  );
}
